import ManageHeader from '@js/utils/manageHeader';
import WindowState from '@js/utils/windowState';
import parseTailwindBreakpoint from '@utils/parseTailwindBreakpoint';

const BREAKPOINT = parseTailwindBreakpoint();

const ProductStickyButton = () => {
  if (window.innerWidth < BREAKPOINT.md) {
    return;
  }

  // config
  const ELEMENT_CLASS = '.Product-buttons';
  const ELEMENT_CHILD_CLASS = '.Product-buttonsItemDesktop';
  const NOT_STICKY_CLASS = 'notSticky';

  const buttons = document.querySelector(ELEMENT_CLASS);

  if (buttons) {
    const manageHeader = ManageHeader(
      ELEMENT_CLASS,
      NOT_STICKY_CLASS,
      'isStuck',
      () => {
        const overlayOpen = document.querySelectorAll('.js-featuresOverlay');
        const header = document.querySelector('#Header');

        if (
          overlayOpen &&
          !buttons.classList.contains('isStuck') &&
          header.classList.contains(NOT_STICKY_CLASS)
        ) {
          overlayOpen.forEach((overlay) => overlay.classList.add('top-0'));
        }

        if (!header.classList.contains(NOT_STICKY_CLASS)) {
          overlayOpen.forEach((overlay) => overlay.classList.remove('top-0'));
        }
      }
    );

    const el = document.querySelector(ELEMENT_CLASS);
    const observer = new IntersectionObserver(
      ([e]) => {
        if (WindowState.TABLET_STATE.get()) return;

        // retrieve background of the component
        const { CURRENT_BACKGROUND_COLOR, CURRENT_CHILD_BACKGROUND_COLOR } =
          window;

        // split to toggle them later
        const classList = CURRENT_CHILD_BACKGROUND_COLOR.split(' ');
        const IS_STUCK = e.intersectionRatio < 1;

        // toggle colors and background-color
        e.target.classList.toggle(CURRENT_BACKGROUND_COLOR, IS_STUCK);
        e.target.classList.toggle(`isStuck`, IS_STUCK);

        // toggle button background and color
        el.querySelectorAll(ELEMENT_CHILD_CLASS).forEach((child) => {
          let color = 'bg-black';

          if (child.dataset.color === 'brand') {
            color = 'bg-brand-600';
          }

          child.classList.toggle(color, !IS_STUCK);

          child.classList.toggle(classList[0], IS_STUCK);
          child.classList.toggle(classList[1], IS_STUCK);

          if (child.dataset.color === 'black') {
            child.classList.toggle('bg-gray-900', !IS_STUCK);
            child.classList.toggle('hover:bg-gray-800', !IS_STUCK);
            child.classList.toggle('focus:bg-gray-800', !IS_STUCK);
          }
        });

        const overlayOpen = document.querySelectorAll('.js-featuresOverlay');

        if (
          overlayOpen &&
          document.querySelector(`#Header.${NOT_STICKY_CLASS}`)
        ) {
          overlayOpen.forEach((overlay) => overlay.classList.remove('top-0'));
        }
      },
      { threshold: [1] }
    );

    observer.observe(el);
    document.addEventListener('scroll', manageHeader);
  }
};

export default ProductStickyButton;
